import { Grid, Stack } from '@mui/material'
import { Field } from 'pages/TeenagersRecord/components/Field'
import React from 'react'
import {
  booleanSimNao,
  formatChoiceText,
  formatInformedQuantity,
  formatText,
} from 'utils/text.util'
import { HearingIdentificationType } from '../../../types/hearing-identification.type'
import { validateStringNumber } from 'components/HearingSummary/utils/validate-field.util'

type TabContentProps = {
  data: HearingIdentificationType
}

export const TabFamilyContent: React.FC<TabContentProps> = ({ data }) => {
  return (
    <Grid item xs={12}>
      <Stack direction='column' spacing={2}>
        <Field label='Nome do pai:' value={[formatText(data.nomePai)]} direction='row' />
        <Field label='Nome da mãe:' value={[formatText(data.nomeMae)]} direction='row' />
        <Field
          label='Reside com quem?'
          value={[formatText(data.identificacaoAdolescente.descricaoIdResidenciaResponsavel)]}
          direction='row'
        />
        {data.identificacaoAdolescente.descricaoIdResidenciaResponsavel === 'OUTRO' && (
          <Field
            label='Qual?'
            value={[formatText(data.identificacaoAdolescente.nomeResponsavelResidenciaOutro)]}
            direction='row'
          />
        )}
        <Field
          label='Adolescente mantém contato com a mãe?'
          value={[formatChoiceText(data.identificacaoAdolescente.mantemContatoMae)]}
          direction='row'
        />
        {!booleanSimNao(data.identificacaoAdolescente.mantemContatoMae) && (
          <Field
            label='Motivo:'
            value={[formatText(data.identificacaoAdolescente.motivoNaoMantemContatoMae)]}
            direction='row'
          />
        )}
        <Field
          label='Adolescente mantém contato com o pai?'
          value={[formatChoiceText(data.identificacaoAdolescente.mantemContatoPai)]}
          direction='row'
        />
        {!booleanSimNao(data.identificacaoAdolescente.mantemContatoPai) && (
          <Field
            label='Motivo:'
            value={[formatText(data.identificacaoAdolescente.motivoNaoMantemContatoPai)]}
            direction='row'
          />
        )}
        <Field
          label='Adolescente recebe pensão alimentícia ou outro auxílio material do representante legal:'
          value={[formatChoiceText(data.identificacaoAdolescente.recebePensaoAlimenticia)]}
          direction='row'
        />
        <Field
          label='Tem filhos?'
          value={[formatChoiceText(data.identificacaoAdolescente.possuiFilho)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.possuiFilho) && (
          <>
            <Field
              label='Quantidade?'
              value={[formatInformedQuantity(data.identificacaoAdolescente.quantidadeFilho)]}
              direction='row'
            />
            <Field
              label={
                'Quem ficará com a guarda? Algum possui deficiência (Artigo 185 Parágrafo 10 do CPP)?'
              }
              value={[formatText(data.identificacaoAdolescente.descricaoGuardaFilho)]}
              direction='row'
            />
          </>
        )}
        <Field
          label='Tem irmãos?'
          value={[formatChoiceText(data.identificacaoAdolescente.possuiIrmao)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.possuiIrmao) && (
          <Field
            label='Quantidade?'
            value={[formatInformedQuantity(data.identificacaoAdolescente.quantidadeIrmao)]}
            direction='row'
          />
        )}
        <Field
          label='Em gestação?'
          value={[formatChoiceText(data.identificacaoAdolescente.estaGestante)]}
          direction='row'
        />
        <Field
          label='Responsáveis trabalham?'
          value={[formatChoiceText(data.identificacaoAdolescente.responsavelTrabalha)]}
          direction='row'
        />
        {booleanSimNao(data.identificacaoAdolescente.responsavelTrabalha) && (
          <>
            <Field
              label='Atividade dos responsáveis?'
              value={[formatText(data.identificacaoAdolescente.descricaoAtividadeResponsavel)]}
              direction='row'
            />
          </>
        )}
        <Field
          label='Renda familiar:'
          value={[validateStringNumber(data.identificacaoAdolescente.descricaoIdRendaFamiliar)]}
          direction='row'
        />
      </Stack>
    </Grid>
  )
}
